var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.658,
    y: 4.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "var(--color-secondary)",
    stroke: "var(--color-secondary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.073 14.333c-.352 0-.516-.223-1.22-.857L8.36 12.088a.58.58 0 010-.883.69.69 0 01.95 0l1.49 1.387a.436.436 0 00.272.126c.136 0 .271-.126.271-.126l3.661-3.404a.69.69 0 01.95 0 .58.58 0 010 .883l-3.662 3.404c-.719.74-.868.857-1.22.857z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/checkbox-check.1fd2d6c95197d68cb5e7b3c9f7237c66.svg";
export { ForwardRef as ReactComponent };